import { connect } from 'react-redux'
import {
  pageRenderLeft,
  pageToggleOverlay,
  setSelectedDeals,
  clearSelectedDeals,
  setSignUpModalIsOpen
} from 'redux/actions'
import ListDeals from 'pages/mwlistdeals/Main'

const mapStateToProps = state => ({
  flavour: state.layout.flavour,
  selectedDeals: state.dealwatch.selectedDeals,
  selectedDealType: state.dealwatch.selectedDealType,
  isLogged: state.user.isLogged,
  isLimitedAccess: state.user.isLimitedAccess,
  browser: state.layout.browser,
  isMobile: state.layout.deviceType.isMobile
})

const mapDispatchToProps = dispatch => ({
  pageRenderLeft: component => dispatch(pageRenderLeft(component)),
  pageToggleOverlay: (component) => dispatch(pageToggleOverlay(component)),
  setSelectedDeals: ({ select, deselect, dealType }) => dispatch(setSelectedDeals({ select, deselect, dealType })),
  clearSelectedDeals: () => dispatch(clearSelectedDeals()),
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(ListDeals)
